import deleteSsoApiCallback from '../utils/deleteSsoApiCallback';
import invokeSsoApiCallback from './invokeSsoApiCallback';
import { hideSsoDialog } from 'owa-addins-store';
import { SsoErrorCode } from '../schema/SsoErrorCode';

export default function hideDialogAndInvokeCallbackOnError(errorCode: SsoErrorCode) {
    invokeSsoApiCallback(errorCode);
    deleteSsoApiCallback();
    hideSsoDialog();
}
